<template >
  <div class="con" v-if="!$store.state.pcshow">
    <img src="../../assets/img/index/companyIntro12.png" alt="" />
    <div class="yj">
      <h4><span></span>孵化器平台</h4>
      <p>通过对物理空间载体，进行持续、高效的经营管理，为处于不同行业领域和发展阶段的产业主体进驻提供服务，同时推动当地产业升级</p>
      <p>聚焦医疗健康领域国内外知名高校、院所、医院成果转化，通过专业化孵化服务和CDMO中试平台，加速推动优质创新成果转化，通过“一院一企一基地”的发展策略，实现区域创新要素集聚发展，构建区域产业创新生态链。</p>
    </div>
  </div>
  <div class="main" v-else>
    
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="stylus" >
  @media screen and (max-width: 960px) {
    .con{
      width: 100%;
      background: #F5F5F5;
      
      >img{
        display: block
        width:7.5rem;
        height:3rem;
      }
      .yj{
        display: block;
        width: calc( 100% - 0.35rem );
        background: #ffffff;
        padding-left:0.35rem;
        padding-bottom:0.38rem;
        border-top: 0.3rem solid #e5e5e5;
        border-bottom: 0.4rem solid #e5e5e5;

        >h4{
          font-size: 0.26rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          line-height: 0.39rem;
          padding-top:0.35rem;
          padding-bottom:0.1rem;

          span{
            display: inline-block;
            width: 0.03rem;
            height: 0.23rem;
            background: #0085D0;
            margin-right:0.07rem;
          }

        }

        p{
            width: 6.8rem;
            font-size: 0.24rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 0.4rem;
        }
        :nth-child(2){
            margin-bottom: 0.2rem;
        }
      }
      
    }
  }
  @media screen and (min-width: 960px) { 
    
  }
</style>